import React, { useState, useEffect } from 'react';
import { usePage } from '../contexts/pageContext';
import styled, { css } from 'styled-components/macro';
import Hemiciclo from '../containers/Graficas/Hemiciclo/Hemiciclo';
import { useTranslate } from '../contexts/languageContext';
import { useNomenclator } from '../contexts/nomenclatorContext';
import TablaPartidos from '../containers/TablaPartidosComposicion/TablaPartidosComposicion';
import LayoutResultados from '../components/LayoutResultados';
import { useEleccion } from '../contexts/eleccionContext';
import { responsive } from '../resources/constantes.json';
import FiltroPartidos from '../containers//TablaPartidosComposicion/FiltroPartidos';

const ResultadosComposicion = () => {
  const pageState = usePage();
  const elecOpts = useEleccion();
  const t = useTranslate();
  const { data, urlInfo } = pageState;
  const { eleccion } = urlInfo;
  const nomenclator = useNomenclator();
  const [filtered, setFiltered] = useState(false);
  const [partidos, setPartidos] = useState(elecOpts.camaras);
  const tableOptions = elecOpts.tableOptions;
  useEffect(() => {
    setPartidos(elecOpts.camaras)
  }, [elecOpts.idEleccion]);
  const ComposicionCamaras = () => {
    return (
      <div>
        <FiltroPartidos
          partidos={elecOpts.camaras}
          setPartidos={setPartidos}
          nomenclator={nomenclator}
          setFiltered={setFiltered}
          filtered={filtered}
        />
        {partidos && partidos.length === elecOpts.camaras.length &&
          partidos.map((camara, index) => {
            return (
              <ContainerCamara key={index}>
                <TextoCamara>
                  {'Circunscripción ' +
                    nomenclator.nomAmbitos[elecOpts.idEleccion].cam[
                      camara.cam
                    ].ca.toLowerCase()}
                  <SeparadorCamaras />
                </TextoCamara>
                <TablaPartidos
                  soloConCargo
                  camaraSeleccionada={camara}
                  mostrarVotos={tableOptions.mostrarVotos}
                  mostrarCargos={tableOptions.mostrarCargos}
                  mostrarCandidatos={tableOptions.mostrarCandidatos}
                />
              </ContainerCamara>
            );
          })}
      </div>
    );
  };

  return (
    <MainContainer>
      <PosiblesCurules>
        Posibles curules:{' '}
        <NumeroCurules>{data.totales['act'].cargtota}</NumeroCurules>
      </PosiblesCurules>
      <LayoutResultados
        leftComponent={ComposicionCamaras()}
        rightComponent={
          <Hemiciclo
            data={data}
            nomenclator={nomenclator}
            idEleccion={eleccion}
          />
        }
      />
    </MainContainer>
  );
};

const SeparadorCamaras = styled.span`
  margin-top: 12px;
  margin-left: 10px;
  border-top: 1px dashed #000000;
  width: 200px;
  display: block;
  @media screen and (max-width: ${responsive.mobile}px) {
    display: none;
  }
`;

const TextoCamara = styled.p`
  display: flex;
  font-size: 22px;
  font-size: 17px;
  margin-bottom: 10px;
  font-weight: 700;
  text-transform: capitalize;
  :first-letter,
  :first-line {
    text-transform: capitalize;
  }
`;

const ContainerCamara = styled.div`
  margin-bottom: 30px;
`;

const NumeroCurules = styled.span`
  font-size: 24px;
  font-weight: 400;
`;

const PosiblesCurules = styled.p`
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: right;
  width: 50%;
  color: #1c4183;
  @media screen and (max-width: ${responsive.mobile}px) {
    text-align: left;
    width: 100%;
  }
`;

const MainContainer = styled.div`
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 16px;

  @media (max-width: 1024px) {
    padding: 0 15px;
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export default ResultadosComposicion;
